import React from "react";
import { Tabs, Typography } from "antd";
import { CarOutlined, CalculatorOutlined, DatabaseOutlined, UnorderedListOutlined } from "@ant-design/icons";
import BtsOrders from "./BtsOrders";
import BtsCalculator from "./BtsCalculator";
import BtsCatalog from "./BtsCatalog";

const { Title } = Typography;

const BtsManager = () => {
    return (
        <div>
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 16,
                paddingBottom: 16,
                borderBottom: "1px solid var(--border)",
            }}>
                <div style={{
                    width: 40, height: 40, borderRadius: "var(--radius-md)",
                    background: "var(--primary-light)", color: "var(--primary)",
                    display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20,
                }}>
                    <CarOutlined />
                </div>
                <div>
                    <Title level={4} style={{ margin: 0, letterSpacing: "-0.01em" }}>BTS yetkazib berish</Title>
                    <span style={{ color: "var(--text-muted)", fontSize: 13 }}>Buyurtmalar holati, narx kalkulyatori va kataloglar</span>
                </div>
            </div>

            <Tabs
                defaultActiveKey="orders"
                items={[
                    {
                        key: "orders",
                        label: <span><UnorderedListOutlined /> Buyurtmalar</span>,
                        children: <BtsOrders />,
                    },
                    {
                        key: "calculator",
                        label: <span><CalculatorOutlined /> Narx kalkulyatori</span>,
                        children: <BtsCalculator />,
                    },
                    {
                        key: "catalog",
                        label: <span><DatabaseOutlined /> Kataloglar</span>,
                        children: <BtsCatalog />,
                    },
                ]}
            />
        </div>
    );
};

export default BtsManager;
